import reducer, { saga as sagas, actions } from './ducks';
import * as translations from './translations';

const widgets = {};
export const name = 'fullBudget';
export const realName = 'fullBudget';
export { reducer, widgets, sagas, actions, translations };
export * from './routes';
